import { Enums } from "@/enums";
import * as devalue from "devalue";
import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const SubscriptionProductChangeRoutes = defineRoute({
    record: {
        route: {
            path: "/subscription-product-change",
            component: () => loadView(import("./SubscriptionProductChangeTable.vue")),
        },
        build(filter?: { status?: Enums.SubscriptionProductChangeStatusEnum.Values[] }) {
            if (isNotNil(filter)) {
                const encoded = btoa(devalue.stringify(filter));
                return `/subscription-product-change?&filter=${encoded}`;
            }

            return "/subscription-product-change";
        },
    },
    create: {
        route: {
            path: "/subscription-product-change/create",
            component: () => loadView(import("./SubscriptionProductChangeCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/subscription-product-change/update/:id",
            component: () => loadView(import("./SubscriptionProductChangeUpdate.vue")),
        },
        build(id: string) {
            return `/subscription-product-change/update/${id}`;
        },
    },
});
